export const getBillingHistoriesUrl = () => '/agency/billing_histories';

export const getBillingHistoryUrl = () => '/agency/billing';

export const getCardDetailsUrl = () => '/agency/payment_methods';

export const getCardDetailUrl = (id: string) => `/agency/payment_methods/${id}`;

export const getAgencyCouponUrl = () => '/agency/apply_coupon';

export const getPayAgencyDuesUrl = () => '/agency/pay_now';

export const getAgencyInvoiceTransactionsUrl = () => '/agency/billing/invoice_transactions';

export const getFetchAgencyInvoiceUrl = (id: number) => `/agency/billing_histories/${id}/fetch_invoice`;

export const getCancelAgencySubscriptionUrl = () => '/agency/billing/cancel_subscription';
